import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';

let apiKey = process.env.VUE_APP_API_KEY;
let authDomain = process.env.VUE_APP_AUTH_DOMAIN;
let projectId = process.env.VUE_APP_PROJECT_ID;
let storageBucket = process.env.VUE_APP_STORAGE_BUCKET;
let messagingSenderId = process.env.VUE_APP_MESSAGING_SENDER_ID;
let appId = process.env.VUE_APP_APP_ID;
const firebaseConfig = {
  apiKey: apiKey,
  authDomain: authDomain,
  projectId: projectId,
  storageBucket: storageBucket,
  messagingSenderId: messagingSenderId,
  appId: appId,
};

firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      // console.log('Service Worker registered:', registration);
    })
    .catch((err) => {
      // console.error('Service Worker registration failed:', err);
    });
}

export { messaging };
